// Default quiz settings
export const DEFAULT_LEVELS = [1, 2];
export const DEFAULT_TYPES = ['Intransitive', 'Transitive'];
export const DEFAULT_FORMS = ['Polite', 'Plain'];
export const AVAILABLE_LEVELS = [1, 2, 3, 4, 5, 6];
